import { apiService } from "@/_services";

const state = {
  all: {}
};

const actions = {
  getAll({ commit }, params) {
    commit("getAllRequest");
    apiService.getAll(params).then(
      total_currency_exposure =>
        commit("getAllSuccess", total_currency_exposure),
      error => commit("getAllFailure", error)
    );
  },
  logout({ commit }) {
    commit("logout");
  }
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, total_currency_exposure) {
    state.all = { items: total_currency_exposure };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  }
};

export const total_currency_exposure = {
  namespaced: true,
  state,
  actions,
  mutations
};
